/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ClientAccountListResponse,
  (requestParams: vp.ClientAccountListRequest) => void,
  () => void,
  (requestParams: vp.ClientAccountListRequest) => Promise<vp.ClientAccountListResponse>,
];

function useFetchClientAccountList({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.ClientAccountListRequest>();
  const [response, setResponse] = useState<vp.ClientAccountListResponse>({
    ErrorMessage: '',
    Success: false,
    ClientAccounts: [],
    PaginationMetaData: {
      TotalRecords: 0,
      Limit: 0,
      Offset: 0,
    },
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ClientAccountListRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchClientAccountList(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.ClientAccountListRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        ClientAccounts: [],
        PaginationMetaData: {
          TotalRecords: 0,
          Limit: 0,
          Offset: 0,
        },
      });
    },
    async (requestParams: vp.ClientAccountListRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchClientAccountList(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchClientAccountList);
